import buildTimeConfig from '../../../config/buildtime.config';
import {
  CHECK_PHONE_EXISTS,
  CHECK_PHONE_EXISTS_FAILED,
  CHECK_PHONE_EXISTS_SUCCESS,
  CREATE_BIZ_ACCOUNT,
  CREATE_BIZ_ACCOUNT_FAILED,
  CREATE_BIZ_ACCOUNT_SUCCESS,
  FORGOT_PASSWORD_PIN,
  FORGOT_PASSWORD_PIN_FAILED,
  FORGOT_PASSWORD_PIN_SUCCESS,
  GET_LOCATION,
  GET_LOCATION_SUCCESS,
  GET_PROFILE_BIZ_CUSTOMER,
  GET_PROFILE_BIZ_CUSTOMER_FAILED,
  GET_PROFILE_BIZ_CUSTOMER_SUCCESS,
  REQUEST_LOGIN,
  REQUEST_LOGIN_FAILED,
  REQUEST_LOGIN_SUCCESS,
  REQUEST_NEW_OTP_CODE,
  REQUEST_NEW_OTP_CODE_FAILED,
  RESET_STATE,
  STORE_BIZ_ACCOUNT_CURRENT_PASSWORD,
  STORE_BIZ_ACCOUNT_CUSTOMER_CODE,
  UPDATE_PASSWORD_PIN,
  UPDATE_PASSWORD_PIN_SUCCESS,
  VERIFY_CODE,
  VERIFY_CODE_FAILED,
  VERIFY_CODE_SUCCESS
} from './actionTypes';
import { AuthState, CheckPhoneActions } from './types';

import { BrowserStorageUtil, cookieStorage } from '@swift-247/s247.library.ui-core';

export const initialState: AuthState = {
  phone: '',
  status: '',
  message: '',
  errorCode: '',
  code: '',
  isValid: false,
  token: '',
  isLoggedIn: false,
  accessToken: '',
  expiresIn: 0,
  refreshToken: '',
  tokenType: '',
  canForgotPassword: null,
  customerCode: '',
  profile: undefined,
  bizPassword: '',
  location: {
    country: [],
    province: [],
    district: [],
    ward: [],
  },
  bizErrors: {},
  isNewAccount: false,
};

export default (state = initialState, action: CheckPhoneActions) => {
  switch (action.type) {
    // check phone number
    case CHECK_PHONE_EXISTS:
      return {
        ...state,
        customerCode: '',
        phone: '',
        profile: undefined,
      };
    case CHECK_PHONE_EXISTS_FAILED:
      return {
        ...state,
        message: action.payload.message,
        status: action.payload.status,
      };
    case CHECK_PHONE_EXISTS_SUCCESS:
      return {
        ...state,
        phone: action.payload.phone,
        customerCode: action.payload.customerCode,
        status: action.payload.status,
        message: action.payload.message,
      };
    // request new OTP
    case REQUEST_NEW_OTP_CODE:
      return {
        ...state,
        message: '',
      };
    case REQUEST_NEW_OTP_CODE_FAILED:
      return {
        ...state,
        message: action.message,
      };
    // verify
    case VERIFY_CODE:
      return {
        ...state,
        // status: '',
        message: '',
        isLoggedIn: false,
        accessToken: '',
      };
    case VERIFY_CODE_FAILED:
      return {
        ...state,
        isValid: action.payload.isValid,
        token: action.payload.token,
        message: action.payload.message,
      };
    case VERIFY_CODE_SUCCESS:
      return {
        ...state,
        isValid: action.payload.isValid,
        token: action.payload.token,
        message: action.payload.message,
      };
    // login
    case REQUEST_LOGIN:
      return {
        ...state,
        message: '',
        isLoggedIn: false,
        profile: undefined,
        accessToken: '',
      };
    case REQUEST_LOGIN_FAILED:
      return {
        ...state,
        message: action.message,
        errorCode: action.errorCode,
      };
    case REQUEST_LOGIN_SUCCESS:
      const newState = {
        ...state,
        isLoggedIn: action.isLoggedIn,
        accessToken: action.accessToken,
        expiresIn: action.expiresIn,
        refreshToken: action.refreshToken,
        tokenType: action.tokenType,
        status: action.status,
      };

      const envStorage =
        buildTimeConfig.env !== 'local' ? localStorage : cookieStorage;

      const browserStorageUtil = new BrowserStorageUtil(envStorage as any);

      browserStorageUtil.serializedSave('authInfo', newState);

      return newState;
    // update password pin
    case UPDATE_PASSWORD_PIN:
      return {
        ...state,
      };
    case UPDATE_PASSWORD_PIN_SUCCESS:
      return {
        ...action,
      };

    case FORGOT_PASSWORD_PIN:
      return {
        ...state,
      };
    case FORGOT_PASSWORD_PIN_SUCCESS:
      state.canForgotPassword = true;
      return {
        ...state,
      };
    case FORGOT_PASSWORD_PIN_FAILED:
      state.canForgotPassword = false;
      state.message = action.payload.message;
      state.errorCode = action.payload.errorCode;
      return {
        ...state,
      };
    case RESET_STATE:
      const stateReset = {
        phone: '',
        status: '',
        message: '',
        errorCode: '',
        code: '',
        isValid: false,
        token: '',
        isLoggedIn: false,
        accessToken: '',
        expiresIn: 0,
        refreshToken: '',
        tokenType: '',
        canForgotPassword: null,
        location: {
          country: [],
          province: [],
          district: [],
          ward: [],
        },
      };
      return { ...stateReset, ...action.payload };
    case GET_PROFILE_BIZ_CUSTOMER:
      return { ...state, isNewAccount: false };
    case GET_PROFILE_BIZ_CUSTOMER_SUCCESS:
      return {
        ...state,
        profile: action.payload,
      };
    case GET_PROFILE_BIZ_CUSTOMER_FAILED:
      return { ...state, ...action };
    case STORE_BIZ_ACCOUNT_CURRENT_PASSWORD:
      return { ...state, password: action.password };
    case STORE_BIZ_ACCOUNT_CUSTOMER_CODE:
      return { ...state, customerCode: action.customerCode };
		case CREATE_BIZ_ACCOUNT:
      return { ...state, profile: null, phone: action.data.company_phone, bizErrors: {} };
    case CREATE_BIZ_ACCOUNT_SUCCESS:
      const { payload } = action;
      return {
        ...state,
        profile: payload,
				phone: payload.company_phone,
				customerCode: payload.customer_code,
        isNewAccount: true,
      };
    case CREATE_BIZ_ACCOUNT_FAILED:
      return { ...state, bizErrors: action.bizErrors };
    case GET_LOCATION:
      return { ...state };
    case GET_LOCATION_SUCCESS:
      const { locationType, data } = action;
      return { ...state, location: { [locationType]: data } };
    default:
      return { ...state };
  }
};
